import { Fragment, useState } from "react";

import { FormControl } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import AlertDialog from "../../components/AlertDialog";
import Autocomplete from "../../components/Autocomplete";
import DatePickerGroup from "../../components/DatePickerGroup";
import NotesInputGroup from "../../components/NotesInputGroup";
import NotesList from "../../components/NotesList";
import PageContent from "../../components/PageContent";
import SatisfactionRating from "../../components/SatisfactionRating";
import SectionTitle from "../../components/SectionTitle";
import StarRatingCard from "../../components/StarRatingCard";
import Stepper from "../../components/Stepper";
import SubjectList from "../../components/SubjectList";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import useDocumentTitle from "../../utils/useDocumentTitle";
import styles from "./Components.module.scss";

import Button from "../../components/Button";

import Grid from "../../components/Grid";
import RadialChart from "../../components/RadialChart";

const skillList = [
  { title: "Skill no.1" },
  { title: "Skill no.2" },
  { title: "Skill no.3" },
  { title: "Skill no.4" },
  { title: "Skill no.5" },
  { title: "Skill no.6" },
  { title: "Skill no.7" },
  { title: "Skill no.8" },
];

export function Components(props) {
  useDocumentTitle(props.title);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [userStatus, setUserStatus] = useState(true);
  const [open, setOpen] = useState(false);
  const [openPostpone, setOpenPostpone] = useState(false);
  const [ratingValue, setRatingValue] = useState(null);

  const [subjectList, setSubjectList] = useState([
    {
      subject: "Subject 1",
      metrics: "90",
      link: "https://google.com",
      subject_id: "",
      metrics: 0,
      occurrence: 0,
      link: "",
    },
    {
      subject:
        "Subject 2 but the name is very long. The quick brown fox jumps over the lazy dog",
      metrics:
        "Metrics also very long. The quick brown fox jumps over the lazy dog.",
      link: "https://google.com",
    },
  ]);

  const [notesList, setNotesList] = useState([
    {
      id: 123,
      type_id: 1,
      note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      like: true,
      author: "Sophia",
    },
    {
      id: 456,
      type_id: 2,
      note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      like: true,
      author: "Jessica",
    },
    {
      id: 456,
      type_id: 3,
      note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      like: true,
      author: "Sophia",
    },
  ]);

  const handleDateChange = date => {
    setSelectedDate(date);
  };
  // get current session duration for the stepper
  const getTotalTime = time => {
    //
  };

  const [openAlertDialog, setOpenAlertDialog] = useState(false);

  const handleAlertDialogClickOpen = () => {
    setOpenAlertDialog(true);
  };

  const handleAlertDialogClose = () => {
    setOpenAlertDialog(false);
  };

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <SectionTitle>{"Components page"}</SectionTitle>
        <PageContent indent>
          <h6>Datepicker</h6>
          <FormControl>
            <DatePickerGroup
              disablePast
              selectedDate={selectedDate}
              handleDateChange={handleDateChange}
            ></DatePickerGroup>
          </FormControl>

          <br />
          <br />

          <div
            style={{
              maxWidth: "400px",
            }}
          >
            <h6>Notes Input Group</h6>
            <NotesInputGroup handleSend={() => { }} />
          </div>

          <br />
          <br />

          <div
            style={{
              maxWidth: "400px",
            }}
          >
            <h6>Notes List</h6>
            <div
              style={{
                padding: "16px",
                backgroundColor: "#EFEFEF",
              }}
            >
              <NotesList list={notesList} setList={setNotesList} />
            </div>
          </div>

          <br />
          <br />

          <div
            style={{
              maxWidth: "400px",
            }}
          >
            <h6>Subject List Input</h6>
            {/* <SubjectListInput
              list={subjectList}
              setList={setSubjectList}
            /> */}
          </div>

          <br />
          <br />

          <div
            style={{
              maxWidth: "400px",
            }}
          >
            <h6>Subject List</h6>
            <SubjectList list={subjectList}></SubjectList>
          </div>

          <br />
          <br />

          <div>
            <h6>Buttons</h6>
            <br />
            <h6>Primary</h6>
            <Button variant="contained" color="primary">
              Button
            </Button>
            <Button variant="outlined" color="primary">
              Button
            </Button>
            <Button variant="outlined" color="primary" disabled>
              Button
            </Button>
            <br />
            <br />
            <h6>Secondary</h6>
            <Button variant="contained" color="secondary">
              Button
            </Button>
            <Button variant="outlined" color="secondary">
              Button
            </Button>
            <Button variant="contained" color="secondary" disabled>
              Button
            </Button>
            <br />
            <br />
            <h6>Small</h6>
            <Button variant="contained" color="primary" size="small">
              Button
            </Button>
            <Button variant="outlined" color="primary" size="small">
              Button
            </Button>
            <Button variant="outlined" color="primary" size="small" disabled>
              Button
            </Button>
            <br />
            <br />
            <Button variant="contained" color="secondary" size="small">
              Button
            </Button>
            <Button variant="outlined" color="secondary" size="small">
              Button
            </Button>
            <Button variant="contained" color="secondary" size="small" disabled>
              Button
            </Button>
          </div>

          <br />
          <br />

          <div>
            <h6>Autocomplete (Coaching Session - Skill to improve)</h6>
            <br />
            <Autocomplete
              id="skillSelect1"
              options={skillList}
              getOptionLabel={option => option.title}
              style={{ width: 300 }}
              renderInput={params => (
                <TextField
                  {...params}
                  placeholder="Select skill"
                  variant="outlined"
                />
              )}
            />
          </div>

          <br />
          <br />

          <div
            style={{
              maxWidth: "400px",
            }}
          >
            <h6>Star Rating Card</h6>
            <StarRatingCard label="Label text" value={2} />
          </div>

          <br />
          <br />

          <div
            style={{
              maxWidth: "400px",
            }}
          >
            <h6>Satisfaction Rating Card</h6>
            <br />
            <SatisfactionRating
              onChange={val => {
                setRatingValue(val);
              }}
            />
            {ratingValue == 1 ? "Happy" : ratingValue == 2 ? "Sad" : ""}
          </div>

          <br />
          <br />

          <div>
            <h6>Stepper</h6>
            <Stepper
              phase="Do"
              phaseLabel="Do"
              sessionId={12}
              clockRun={true}
              getTotalTimeSpent={getTotalTime}
            />
          </div>

          <br />
          <br />

          <div>
            <h6>Switch </h6>
            <FormControlLabel
              control={
                <Switch
                  checked={userStatus}
                  onChange={e => {
                    setUserStatus(e.target.checked);
                  }}
                  name="userStatus"
                />
              }
              label={userStatus ? "Active" : "Deactivate"}
            />
          </div>

          <br />
          <br />

          <div style={{ maxWidth: "600px" }}>
            <h6>Alert Dialog</h6>
            <br />
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                setOpen(true);
              }}
            >
              Click me!
            </Button>
            <AlertDialog
              open={open}
              onClose={() => {
                setOpen(false);
              }}
              title="Dialog title"
              body="Dialog body text. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
              footer={
                <Fragment>
                  <Button color="primary" variant="contained">
                    Button text
                  </Button>
                </Fragment>
              }
            />
          </div>

          <br />
          <br />

          <div style={{ maxWidth: "600px" }}>
            <h6>Postpone review session</h6>
            <br />
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                setOpenPostpone(true);
              }}
            >
              Postpone review session
            </Button>
            <AlertDialog
              maxWidth="xs"
              open={openPostpone}
              onClose={() => {
                setOpenPostpone(false);
              }}
              title="Postpone review session to"
              body={
                <Fragment>
                  <div className={"margin-bottom-16"}>
                    <DatePickerGroup
                      disablePast
                      selectedDate={selectedDate}
                      handleDateChange={handleDateChange}
                    />
                  </div>
                  <TextField
                    className={styles.textarea}
                    multiline
                    rows={4}
                    fullWidth
                    placeholder="Comment"
                    variant="outlined"
                  />
                </Fragment>
              }
              footer={
                <Fragment>
                  <Button size="small">Cancel</Button>
                  <Button color="primary" variant="contained" size="small">
                    Schedule
                  </Button>
                </Fragment>
              }
            />
          </div>
          <br />
          <br />
          <div style={{ maxWidth: "600px" }}>
            <h6>RadialChart</h6>
            <Grid>
              <RadialChart
                color={"#D55757"}
                percentage="80"
                title="Happiness"
                label="Rated session <span>(16)</span> / Total sessions <span>(20)</span>"
              />
              <RadialChart
                color={"#FF9C12"}
                percentage="72"
                title="Compliment likes"
                label="Likes <span>(18)</span> / Total Compliments <span>(25)</span>"
              />
              <RadialChart
                color={"#13C77A"}
                percentage="73"
                title="Success"
                label="Pass rate <span>(22)</span> / Total subjects <span>(30)</span>"
              />
            </Grid>
          </div>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
